export const packageFreeShippingDecorator = (groupData, freeShippingPromoThresholdValue) => {
    if (groupData.products) {
        groupData.products.forEach((product) => {
            // define if free shipping promo applicable for the package
            const packagePrice = Number.parseFloat(product.retailPrice)
            product.freeShipping = 
                !Number.isNaN(packagePrice) 
                && !Number.isNaN(freeShippingPromoThresholdValue) 
                && packagePrice > freeShippingPromoThresholdValue
        })
    }
}
